import { Injectable } from '@angular/core';
import { MojaFirmaClient, SubscriptionPackage } from '@kodit/core/data-api';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './security/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PracenjeLageraService {
  constructor(
    private _authService: AuthService,
    private _client: MojaFirmaClient
  ) {}

  prikaziLager(): Observable<boolean> {
    if (
      this._authService.hasPackage([
        SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
        SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
      ])
    ) {
      return of(true);
    }

    if (
      !this._authService.hasPackage(
        SubscriptionPackage[SubscriptionPackage.EOTPREMNICE]
      )
    ) {
      return of(false);
    }

    return this._client.getKonfiguracija().pipe(
      map((res) => !!res.data?.pracenjeLageraZaEOtpremnice),
      catchError(() => of(false))
    );
  }
}
